export const productsApiPath = {
  getPopularProducts: (snsTitle: string) => `/v2/curations/${snsTitle}/popular-products`,
  getLikedProducts: '/v2/products/liked',
  searchProducts: '/v2/products/search',
  createProductLink: `/v2/link/product`,
} as const;
